/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { WatchStickinessServiceRepositoryImplV2 } from '../impls';
import { IWatchStickinessService, IWatchStickinessServiceRepository } from '../interfaces';
import { TCollectionActivityStoreParams, TServicesParams } from '../types';

export class WatchStickinessService implements IWatchStickinessService {
    private oWatchStickinessServiceRepositoryV2: IWatchStickinessServiceRepository;

    public constructor(params: TServicesParams) {
        this.oWatchStickinessServiceRepositoryV2 = new WatchStickinessServiceRepositoryImplV2(
            params,
        );
    }

    /**
     * @inheritdoc
     */
    public async setCollectionActivityStoreV2(
        collectionActivityStoreParams: TCollectionActivityStoreParams,
    ) {
        return this.oWatchStickinessServiceRepositoryV2.createCollectionActivityStoreV2(
            collectionActivityStoreParams,
        );
    }
}
